export const PageHeader = {
  baseStyle: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  defaultProps: {},
  variants: {},
};
